<template>
  <div class="tabs-container" :class="{ 'tabs-container__h5': isH5 }">
    <div class="tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ active: tab.isActive }"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </div>
      <div ref="indicator" class="indicator" />
    </div>
  </div>
</template>
<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    tabsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabs: [],
      mouseOver: false,
      isH5: isH5(),
    };
  },
  watch: {
    tabsData: {
      handler(newVal) {
        this.tabs = newVal;
        if (this.tabs.length) {
          const index = this.tabs.findIndex((tab) => tab.isActive);
          this.updateIndicatorPosition(index);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateIndicatorPosition(0);
  },
  methods: {
    selectTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.isActive = i === index;
      });
      this.updateIndicatorPosition(index);
      this.$emit("change", this.tabs[index]);
    },
    updateIndicatorPosition(index) {
      if (this.$el) {
        const tab = this.$el.querySelector(`.tab:nth-child(${index + 1})`);
        if (!tab) return;
        const rect = tab.getBoundingClientRect();
        const tabsRect = this.$el
          .querySelector(".tabs")
          .getBoundingClientRect();
        const indicatorWidth = tab.offsetWidth;
        const indicatorLeft =
          rect.left -
          tabsRect.left +
          indicatorWidth / 2 -
          this.$refs.indicator.offsetWidth / 2;

        this.$refs.indicator.style.transform = `translateX(${indicatorLeft}px)`;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.tabs-container {
  display: flex;
  justify-content: flex-start;
  .tabs {
    display: flex;
    position: relative;
  }
  .tab {
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    border: none;
    outline: none;
    font-weight: 400;
    font-size: 20px;
    color: #515350;
    margin-right: 52px;
    &:last-child {
      margin-right: 0;
    }
  }

  .tab.active {
    color: $saas-text-color;
    font-weight: 500;
  }
  .indicator {
    position: absolute;
    bottom: -7px;
    width: 20px;
    height: 3px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 2px;
    transition: transform 0.3s ease;
  }
}

.tabs-container__h5 {
  padding: 0.3733rem 0 0.48rem 0.48rem;
  .tab {
    height: 0.6rem;
    line-height: 0.6rem;
    font-size: 0.4267rem;
    margin-right: 0.5333rem;
    &:last-child {
      margin-right: 0;
    }
  }
  .indicator {
    bottom: -0.2133rem;
    width: 0.2133rem;
    height: 0.08rem;
    border-radius: 0.0533rem;
  }
}
</style>
